import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DateRoomType } from '../models/date-room-type';
import { Observable } from 'rxjs/Observable';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { OverviewHttpService } from './overview.http.service';

@Injectable()
export class OverviewStore {

  private currentDateRoomTypeSummary: BehaviorSubject<DateRoomType> = new BehaviorSubject(null);

  constructor(
    private flashMessagesService: FlashMessagesService,
    private overviewHttpService: OverviewHttpService,
  ) {}

  get dateStaySummary(): Observable<DateRoomType> {
    return this.currentDateRoomTypeSummary.asObservable();
  }

  /**
   * Has to be called to retrieve Date Room Type Summary.
   * Is called by resolver.
   *
   * @param eventId
   * @returns DateRoomTypeDetail list
   */
  loadDateRoomTypeSummary(eventId: number): Observable<DateRoomType> {
    return this.overviewHttpService.getDateRoomTypeSummary(eventId)
      .catch((error: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.COULD_NOT_GET_DATE_ROOM_TYPE_SUMMARY',
          `Error retrieving summary: Total Rooms By Date & Room Type: ${error}`
        );
        return Observable.throw(error);
      })
      .map((res: DateRoomType) => {
        this.currentDateRoomTypeSummary.next(res);
        return res;
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/service/overview.store.ts